<template>
    <div>
        <div :class="{ window: true, white: true, poollist: true, showLargeView }">
            <PoolList :handleViewMyPools="handleViewMyPools"
                :handleUpdateResolvedAddress="handleUpdateResolvedAddress" />
            <UserPoolTotals v-if="showLargeView" :resolvedAddress="resolvedAddress" />
        </div>
        <TotalBalances />
    </div>
</template>

<script>
import PoolList from '@/components/common/PoolList.vue'
import UserPoolTotals from '@/components/common/UserPoolTotals.vue'
import TotalBalances from '@/components/root/TotalBalances.vue'

const updateDashboardUrl = (address) => {
    window.history.replaceState(undefined, '', address ? `?see=${address}` : '?');
};

export default {
    metaInfo: {
        title: 'Curve.finance :: Pools',
        // meta: [
        //   {'property': 'og:title', 'content': 'curve.finance/curve_audits'},
        //   {'property': 'og:url', 'content': 'https://classic.curve.finance/curve_audits'},
        //   {'property': 'og:type', 'content': 'website'},
        //   {'property': 'og:description', 'content': 'Curve is an exchange liquidity pool on Ethereum designed for extremely efficient stablecoin trading'},
        //   {'property': 'og:image', 'content': '/curve.png'},
        //   {'name': 'twitter:card', 'content': 'summary_large_image'},
        //   {'name': 'twitter:title', 'content': 'curve.finance/curve_audits'},
        //   {'name': 'twitter:site', 'content': '@CurveFinance'},
        //   {'name': 'twitter:creator', 'content': '@CurveFinance'},
        //   {'name': 'twitter:description', 'content': 'Curve is an exchange liquidity pool on Ethereum designed for extremely efficient stablecoin trading'},
        //   {'name': 'twitter:url', 'content': 'https://classic.curve.finance/curve_audits'},
        //   {'name': 'twitter:image', 'content': '/curve.png'},
        // ]
    },

    components: {
        PoolList,
        UserPoolTotals,
        TotalBalances,
    },

    data: () => ({
        showLargeView: false,
        viewedAddress: '', // Displayed address (e.g. ENS address)
        resolvedAddress: '', // Resolved address (always a valid hex address)
    }),

    computed: {
        publicPath() {
            return process.env.BASE_URL
        },
    },

    methods: {
        handleViewMyPools(isVisible) {
            this.showLargeView = isVisible;

            if (isVisible) updateDashboardUrl(this.viewedAddress);
            else updateDashboardUrl('');
        },

        handleUpdateResolvedAddress(viewedAddress, resolvedAddress) {
            this.viewedAddress = viewedAddress;
            this.resolvedAddress = resolvedAddress;

            if (resolvedAddress && this.showLargeView) {
                updateDashboardUrl(viewedAddress);
            }
        }
    },
}
</script>

<style scoped>
legend {
    text-align: center;
}

.window.window {
    width: 95%;
    max-width: 900px;
    box-sizing: border-box;
}

.window.window.poollist {
    min-width: fit-content;
}

.window.window.showLargeView {
    width: 95%;
    max-width: 1280px;
    box-sizing: border-box;
}

@media only screen and (max-device-width : 900px) {
    .window.window.showLargeView {
        width: 100%;
        min-width: fit-content;
    }

}

@media only screen and (max-device-width: 730px) {
    .window.window.poollist {
        padding-left: 0;
        padding-right: 0;
        border-left: 0;
        border-right: 0;
        margin-right: auto;
        margin-left: auto;
    }
}
</style>
